export default "__VITE_ASSET__B5_8ahg4__"